import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicFormControls, BasicTextArea, BaasicButton, BasicFieldCheckbox } from 'core/components';

function NikoTemplateMissingDocumentNoteModalTemplate({ nikoTemplateMissingDocumentNoteModalStore , t}) {
    const {
        patientTemplateMissingDocument,
        form,
        modalParams
    } = nikoTemplateMissingDocumentNoteModalStore;

    const onKeyDown = (e) => {
        if (e.keyCode == 13) {
            e.preventDefault();
            form.onSubmit(e);
        }
    }

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>{patientTemplateMissingDocument.missingDocument.name}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    <BasicTextArea field={form.$('note')} nKeyDown={onKeyDown} isFocus={true}/>
                </div>
                <div className="form__group">
                    <BasicFieldCheckbox field={form.$('isPreviousDos')} />
                </div>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicFormControls
                    form={form} 
                    onSubmit={form.onSubmit} 
                    disabled={form.submitting || form.validating} 
                    label="Save"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section>
    )
}
 
NikoTemplateMissingDocumentNoteModalTemplate.propTypes = {
    nikoTemplateMissingDocumentNoteModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(NikoTemplateMissingDocumentNoteModalTemplate);
